export const ORG_TYPES = {
  TIERED_SELF_SERVE: "tiered_self_serve",
  SALES_PROSPECTING: "sales_prospecting",
  FREE_TRIAL: "free_trial",
}

export const PRODUCT_TIERS = {
  MAX: "max",
  PRO: "pro",
  ENTERPRISE: "enterprise",
}
